import { TransportTypeEnum } from '../../enums/trip/trip-type.enum'
import { TripStepTypeEnum } from '../../enums/trip-bookings/trip-step-type.enum'
import { TripBookingProperties } from '../trip-booking/properties.trip-booking'
import { TripBookingTypes } from '../trip-booking/trip-booking'
import { TripFolder } from './trip-folder'

export class TripFolderProperties {
  static getFirstTripStep(tripBooking: TripBookingTypes.Basic) {
    return TripBookingProperties.sortTripStepsById(tripBooking.tripSteps)?.at(0)
  }

  static getLastTripStep(tripBooking: TripBookingTypes.Basic) {
    return TripBookingProperties.sortTripStepsById(tripBooking.tripSteps)?.at(-1)
  }

  static getDepartureTime(tripBooking: TripBookingTypes.Basic) {
    return this.getFirstTripStep(tripBooking)?.departureTime
  }

  static getArrivalTime(tripBooking: TripBookingTypes.Basic) {
    return this.getFirstTripStep(tripBooking)?.arrivalTime
  }

  static getDepartureTimeZone(tripBooking: TripBookingTypes.Basic) {
    return this.getFirstTripStep(tripBooking)?.departureTimeZone
  }

  static getArrivalTimeZone(tripBooking: TripBookingTypes.Basic) {
    return this.getFirstTripStep(tripBooking)?.arrivalTimeZone
  }

  static getDeparturePlace(tripBooking: TripBookingTypes.Basic) {
    return this.getFirstTripStep(tripBooking)?.departurePlace
  }

  static getArrivalPlace(tripBooking: TripBookingTypes.Basic) {
    return this.getFirstTripStep(tripBooking)?.arrivalPlace
  }

  static getTrip(tripBooking: TripBookingTypes.Light) {
    return tripBooking.relatedTrip
  }

  static getMeetingTimeForParents(
    tripBooking: TripBookingTypes.Light,
    directionality?: TripStepTypeEnum
  ) {
    if (directionality) {
      const tripSteps = TripBookingProperties.getTripStepsByDirectionality(
        directionality,
        tripBooking
      )
      const tripStep =
        directionality === TripStepTypeEnum.INBOUND ? tripSteps?.at(0) : tripSteps?.at(-1)

      return directionality === TripStepTypeEnum.INBOUND
        ? tripStep?.timeBeforeDepartureForParents
        : tripStep?.timeBeforeArrivalForParents
    }

    if (tripBooking.directionality === TransportTypeEnum.ONE_WAY)
      return this.getFirstTripStep(tripBooking)?.timeBeforeDepartureForParents

    return this.getLastTripStep(tripBooking)?.timeBeforeArrivalForParents
  }

  static getMeetingTimeForParentsTimeZone(
    tripBooking: TripBookingTypes.Light,
    directionality?: TripStepTypeEnum
  ) {
    if (directionality) {
      const tripSteps = TripBookingProperties.getTripStepsByDirectionality(
        directionality,
        tripBooking
      )
      const tripStep =
        directionality === TripStepTypeEnum.INBOUND ? tripSteps?.at(0) : tripSteps?.at(-1)

      return directionality === TripStepTypeEnum.INBOUND
        ? tripStep?.departureTimeZone
        : tripStep?.arrivalTimeZone
    }

    if (tripBooking.directionality === TransportTypeEnum.ONE_WAY)
      return this.getFirstTripStep(tripBooking)?.departureTimeZone

    return this.getLastTripStep(tripBooking)?.arrivalTimeZone
  }

  static getTripBookingsDetails(tripFolder: TripFolder) {
    return tripFolder.tripBookings.map((booking) => ({
      meetingTimeForParents: this.getMeetingTimeForParents(booking, tripFolder.directionality),
      meetingTimeForParentsTimeZone: this.getMeetingTimeForParentsTimeZone(
        booking,
        tripFolder.directionality
      ),
      departureTime: this.getDepartureTime(booking),
      arrivalTime: this.getArrivalTime(booking),
      departurePlace: this.getDeparturePlace(booking),
      arrivalPlace: this.getArrivalPlace(booking),
      departureTimeZone: this.getDepartureTimeZone(booking),
      arrivalTimeZone: this.getArrivalTimeZone(booking),
      trip: this.getTrip(booking)
    }))
  }
}
